// Generated by scripts/scope-tours/order.ts. Do not edit by hand.
// The order the library teaches its modules in, inferred from the docs:
// sections as the library has them, topics within a section ordered by which
// concept the docs lean on, and modules within a topic by the docs' own
// heading order. A scope missing here sorts last.
export const CURRICULUM: string[] = [
    'view:Tags',
    'view:SavedChart',
    'manage:ExportCsv',
    'view:Dashboard',
    'view:DashboardComments',
    'view:Space',
    'view:PinnedItems',
    'manage:Tags',
    'manage:SavedChart',
    'manage:Dashboard',
    'create:DashboardComments',
    'manage:DashboardComments',
    'manage:ContentVerification',
    'create:Space',
    'manage:Space',
    'manage:ProjectHomepage',
    'manage:PinnedItems',
    'view:CompiledSql',
    'view:UnderlyingData',
    'manage:Explore',
    'manage:SqlRunner',
    'manage:CustomSqlTableCalculations',
    'manage:CustomFields',
    'create:VirtualView',
    'create:AiAgentThread',
    'manage:AiAgent',
    'create:AiDeepResearch',
    'create:DataApp',
    'manage:DataApp',
];
